import { UPDATE_TARGET, REFRESH_TABLE } from '@/views/audienceHub/store/actions'
import {
  fetchSingleTarget,
  fetchNetworksConfig,
  fetchTargetData,
  fetchAgeDistribution,
  fetchIncomeDistribution,
  exportTargetDefinition,
  getUploadTargetData,
  getTargetPidLists,
  rePostTarget,
  getDroppedAttributesByQuarter,
} from '@/api'
import Toast from '@/components/common/toasts'
import { targetRouteHandler } from '@/helpers'

import { difference, map, filter } from 'lodash'
import Bluebird from 'bluebird'

// TODO put these inside there own appLogic folder
import { transformUniverseDataForGraph } from '@/appComponents/workbench/lasGraphs/chartDataHelpers'
import { incomeGraphData } from '@/appLogic/marketBreaks/IncomeMarketBreaks'
import { ageDistributionGraphData, marketBreakAveragesGraphData, getMeanOfAges } from '@/appLogic/marketBreaks/AgeMarketBreaks'
import { fetchEsDateRanges } from '@/api/index'
import downloadTarget from '../DownloadTarget'
import { TARGET_TYPE, ACTIVATION_STATUS } from '../../Constants'
import { UPDATE_TARGET_STATUS } from '@/appLogic/targets/createTarget/store/actions'

const module = 'CURRENT_TARGET_'

export const SET_CURRENT_TARGET = module + 'SET_CURRENT_TARGET'
// This is the selected Netowrks for the current target
export const SET_SELECTED_VIEWERSHIP_NETWORKS = module + 'SET_SELECTED_VIEWERSHIP_NETWORKS'
export const UPDATE_SELECTED_VIEWERSHIP_NETWORKS = module + 'UPDATE_SELECTED_VIEWERSHIP_NETWORKS'
export const SELECT_NETWORK_DAY_PART = module + 'SELECT_NETWORK_DAY_PART'
export const REMOVE_FROM_SELECTED_DAY_PART_NETWORKS = module + 'REMOVE_FROM_SELECTED_DAY_PART_NETWORKS'
export const ADD_TO_SELECTED_DAY_PART_NETWORKS = module + 'ADD_TO_SELECTED_DAY_PART_NETWORKS'
export const CLOSE_DAY_PARTS_SECTION = module + 'CLOSE_DAY_PARTS_SECTION'
export const SHOW_DELETE_TARGET_MODAL = module + 'SHOW_DELETE_TARGET_MODAL'
export const SET_SHOW_APPEND_MODAL = module + 'SET_SHOW_APPEND_MODAL'
export const SET_SHOW_PID_DOWNLOAD_MODAL = module + 'SET_SHOW_PID_DOWNLOAD_MODAL'
export const SET_TARGET_REPOST_DATES = module + 'SET_TARGET_REPOST_DATES'
export const SET_TARGET_SEGMENTS = module + 'SET_TARGET_SEGMENTS'
export const SET_TARGET_PID_LISTS = module + 'SET_TARGET_PID_LISTS'
export const RESET_TARGET_PID_LISTS = module + 'RESET_TARGET_PID_LISTS'
export const RESET_TARGET_SEGMENTS = module + 'RESET_TARGET_SEGMENTS'
export const DELETE_CURRENT_TARGET = module + 'DELETE_CURRENT_TARGET'
export const SET_LOADING_VALUE = module + 'SET_LOADING_VALUE'
export const SELECT_MARKET_DEMO = module + 'SELECT_MARKET_DEMO'
export const SET_CURRENT_TARGET_DEFINITION = module + 'SET_CURRENT_TARGET_DEFINITION'
export const SET_UPLOAD_MODAL_OPTIONS = module + 'SET_UPLOAD_MODAL_OPTIONS'
export const SHOW_REPOSSTING_MODAL = module + 'SHOW_REPOSSTING_MODAL'
export const REPOST_TARGET = module + 'REPOST_TARGET'
export const SET_TARGET_DROPPED_ATTRIBUTES = module + 'SET_TARGET_DROPPED_ATTRIBUTES'
export const SET_TARGET_NAME = module + 'SET_TARGET_NAME'
export const SET_TARGET_ADVERTISER = module + 'SET_TARGET_ADVERTISER'
export const SHOW_DROPPED_ATTRIBUTES_MODEL = module + 'SHOW_DROPPED_ATTRIBUTES_MODEL'
export const NPOWER_TARGET_UPLOAD_FAILED = module + 'NPOWER_TARGET_UPLOAD_FAILED'

// DOWNLOADING TARGETS
export const DOWNLOAD_LAS_TARGET = module + 'DOWNLOAD_LAS_TARGET'
export const DOWNLOAD_TARGET_DEFINITION = module + 'DOWNLOAD_TARGET_DEFINITION'
export const IS_DOWNLOADING_TARGET = module + 'IS_DOWNLOADING_TARGET'
export const REMOVE_IS_DOWNLOADING_TARGET = module + 'REMOVE_IS_DOWNLOADING_TARGET'
export const IS_COMPLETED_DOWNLOAING_TARGET = module + 'IS_COMPLETED_DOWNLOAING_TARGET'
export const CLEAR_TARGET_DOWNLOAD = module + 'CLEAR_TARGET_DOWNLOAD'

const actions = {
  [SET_CURRENT_TARGET] (context, target) {
    context.commit(SET_CURRENT_TARGET, target)
    context.dispatch(SET_SELECTED_VIEWERSHIP_NETWORKS)
  },
  [CLOSE_DAY_PARTS_SECTION] ({ commit }) {
    commit(CLOSE_DAY_PARTS_SECTION)
  },
  [SET_SELECTED_VIEWERSHIP_NETWORKS] (context) {
    let target = context.state.currentTarget
    let networks = context.getters.networks
    if (target.workbench_data) {
      const selectedNetworks = target.workbench_data.networks
        ? target.workbench_data.networks
        : map(
            filter(networks, network => network.turner),
            network => network.id
          )
      context.commit(SET_SELECTED_VIEWERSHIP_NETWORKS, selectedNetworks)
    }
  },
  // DEPRECATED
  [UPDATE_SELECTED_VIEWERSHIP_NETWORKS] ({ commit, state, dispatch }, networks) {
    // if the new selected networks does not include the networks selected for day parts
    // remove the unselected networks from day parts
    let missingSelectedDayPartNetworks = difference(state.selectedDayPartNetworks, networks)
    if (missingSelectedDayPartNetworks.length > 0) {
      missingSelectedDayPartNetworks.forEach(network => {
        dispatch(SELECT_NETWORK_DAY_PART, network)
      })
    }
    commit(SET_SELECTED_VIEWERSHIP_NETWORKS, networks)
  },
  // DEPRECATED
  [SELECT_NETWORK_DAY_PART] ({ commit, state }, network) {
    // las workbench or some other store for the daypart information.
    // so that it is easier to control.
    const alreadySelectedIndex = state.selectedDayPartNetworks.indexOf(network)
    if (alreadySelectedIndex > -1) {
      commit(REMOVE_FROM_SELECTED_DAY_PART_NETWORKS, alreadySelectedIndex)
    } else {
      commit(ADD_TO_SELECTED_DAY_PART_NETWORKS, network)
    }
  },
  [SHOW_DELETE_TARGET_MODAL]: context => {
    context.commit(SHOW_DELETE_TARGET_MODAL)
  },
  [SET_SHOW_APPEND_MODAL] (context, { target, showModal }) {
    showModal = !(showModal === false)
    if (!showModal && !target) {
      context.commit(SET_SHOW_APPEND_MODAL)
    } else if (target.target === TARGET_TYPE.NPOWER || target.target === TARGET_TYPE.COMSCORE) {
      context.commit(SET_LOADING_VALUE, true)
      if (showModal) {
        context.commit(SET_SHOW_APPEND_MODAL, target)
      } else {
        context.commit(SET_CURRENT_TARGET, target)
      }
      getUploadTargetData({ target_type: target.target, id: target.id })
        .then(function (response) {
          context.commit(SET_LOADING_VALUE, false)
          if (response.error) {
            Toast.error({
              title: 'Error:',
              message: 'There was an error getting uploaded data of your target.',
              timeout: 7000
            })
            context.commit(SET_SHOW_APPEND_MODAL, false)
          } else {
            context.commit(SET_TARGET_SEGMENTS, response.data)
          }
        })
        .catch(function (e) {
          console.error(e)
          context.commit(SET_LOADING_VALUE, false)
        })
    }
  },
  [NPOWER_TARGET_UPLOAD_FAILED]: (context, targetId) => {
    context.commit(REFRESH_TABLE, false)
    context.dispatch(SET_SHOW_APPEND_MODAL, {showModal: false})
    context.dispatch(UPDATE_TARGET_STATUS, {targetId: targetId, activation_status: ACTIVATION_STATUS.FAILED}).then(() => {
      context.dispatch(REFRESH_TABLE, true)
    })
  },
  [SET_SHOW_PID_DOWNLOAD_MODAL]: (context, target) => {
    context.commit(SET_LOADING_VALUE, true)
    context.commit(SET_SHOW_PID_DOWNLOAD_MODAL, target)
    getTargetPidLists(target.id).then(function (response) {
      context.commit(SET_LOADING_VALUE, false)
      context.commit(SET_TARGET_PID_LISTS, response.data)
    })
  },
  [RESET_TARGET_PID_LISTS]: context => {
    context.commit(SET_TARGET_PID_LISTS, [])
  },
  [RESET_TARGET_SEGMENTS]: context => {
    context.commit(SET_TARGET_SEGMENTS, [])
  },
  [DELETE_CURRENT_TARGET]: context => {
    targetRouteHandler('DELETE', context.state.currentTarget)
  },
  [IS_COMPLETED_DOWNLOAING_TARGET] (context, targetId) {
    context.commit(REMOVE_IS_DOWNLOADING_TARGET, targetId)
    context.commit(IS_COMPLETED_DOWNLOAING_TARGET, targetId)
  },
  [CLEAR_TARGET_DOWNLOAD] (context) {
    context.commit(CLEAR_TARGET_DOWNLOAD)
  },
  [SET_CURRENT_TARGET_DEFINITION] (context, td) {
    context.commit(SET_CURRENT_TARGET_DEFINITION, td)
  },
  [SHOW_REPOSSTING_MODAL] (context, target) {
    fetchEsDateRanges(target.target_datasource).then(dates => {
      context.dispatch(SET_CURRENT_TARGET, target)
      context.commit(SET_TARGET_REPOST_DATES, dates.dateRanges)
      context.commit(SHOW_REPOSSTING_MODAL)
    })
  },
  [SET_TARGET_DROPPED_ATTRIBUTES] (context, target) {
    context.commit(SET_LOADING_VALUE, true)
    // makes call out to AM-API to get dropped attributes
    getDroppedAttributesByQuarter({ target_id: target.id })
      .then(resp => {
        context.commit(SET_TARGET_DROPPED_ATTRIBUTES, resp.data)
        context.commit(SET_LOADING_VALUE, false)
      })
      .catch(resp => {
        context.commit(SET_LOADING_VALUE, false)
      })
  },
  [SHOW_DROPPED_ATTRIBUTES_MODEL] (context, shouldShow) {
    context.commit(SHOW_DROPPED_ATTRIBUTES_MODEL, shouldShow)
  },
  [REPOST_TARGET] (context, start_date) {
    const target = context.state.currentTarget
    rePostTarget({ target_id: target.id, start_date })
      .then(response => {
        context.commit(UPDATE_TARGET, { id: response.data.id, updatedTarget: response.data })
        Toast.success({
          title: 'Re-forecasting successful',
          message: `The target "${target.display_name}", has been re-forecasted starting from ${start_date}`,
        })
      })
      .catch(er => {
        Toast.error({
          title: 'Error Re-forecasting',
          message: `There was an error re-forecasting the target "${target.display_name}"`,
        })
      })
  },
  [DOWNLOAD_LAS_TARGET] (context, target) {
    // now that we have the target
    // 1. fetch the data
    Toast.info({ title: 'Downloading the Target Package', message: 'Your download is in progress, will notify you on completion.' })
    context.commit(IS_DOWNLOADING_TARGET, target.id)
    // TODO need to change this for the full target
    fetchSingleTarget({
      target_id: target.id,
    })
      .then(({ data }) => {
        let targetDefinition = data.target_definition.query
        if (targetDefinition) {
          Bluebird.join(
            fetchTargetData(data.target_definition), // data
            fetchAgeDistribution(data.target_definition),
            fetchIncomeDistribution(data.target_definition),
            fetchNetworksConfig(), // networkResp
            function (data, age, income, networksResp) {
              let networks = networksResp.networks
              let audienceSize = data.audienceSize && data.audienceSize.audience
              let universe = data.universe
              let viewershipData = data.historicalViewership
              let ageData = age.data.data
              let incomeData = income.data.data
              let ageMarketData = marketBreakAveragesGraphData(ageData)
              let ageDistribution = ageDistributionGraphData(ageData)
              let meanAge = getMeanOfAges(ageData)
              let incomeDistribution = incomeGraphData(incomeData)
              let universeData = transformUniverseDataForGraph(universe)
              downloadTarget({ target, audienceSize, targetDefinition, viewershipData, networks, universeData, ageMarketData, meanAge, ageDistribution, incomeDistribution }).then(filename => {
                context.dispatch(IS_COMPLETED_DOWNLOAING_TARGET, target.id)
                Toast.success({ title: 'Target Download Complete', message: `Completed downloading the file ${filename}.` })
              })
            }
          )
        } else {
          context.dispatch(IS_COMPLETED_DOWNLOAING_TARGET, target.id)
          Toast.error({ title: 'Target Definition Missing', message: `Cannot Download because the target is missing its Target Definition.` })
        }
      })
      .catch(err => {
        context.dispatch(IS_COMPLETED_DOWNLOAING_TARGET, target.id)
        Toast.error({ title: 'Error has occurred', message: `Error: ${err.message}` })
      })
  },
  [DOWNLOAD_TARGET_DEFINITION] (context, payload) {
    Toast.info({ title: 'Downloading Target Definition', message: 'Your download is in progress, will notify you on completion.' })
    console.log(payload)
    exportTargetDefinition(payload)
      .then(() => Toast.success({ title: 'Successfully Downloaded Target Definition', message: 'Your download is complete!' }))
      .catch(err => {
        console.error(err)
        Toast.error({ title: 'Error Downloading Target Definition', message: err.message })
      })
  },
  [SET_TARGET_NAME] (context, name) {
    context.commit(SET_TARGET_NAME, name)
  },
  [SET_TARGET_ADVERTISER] (context, name) {
    context.commit(SET_TARGET_ADVERTISER, name)
  },
}

export default actions



// WEBPACK FOOTER //
// ./src/app/appLogic/targets/currentTarget/store/actions.js